package migrations

import kotlin.Boolean
import kotlin.ByteArray
import kotlin.Long
import kotlin.String

public data class AnswerFileTable(
  public val id: String,
  public val answerId: String,
  public val name: String,
  public val originalName: String?,
  public val path: String?,
  public val size: Long?,
  public val type: String?,
  public val blob: ByteArray?,
  public val uploadStatus: String?,
  public val hasGenerateChunk: Boolean?,
)
